export default __webpack_public_path__ + "static/media/avatar-01.a21f07d7.svg";